import MeshGradient from 'react-scale/components/elements/webgl/mesh-gradient';

const MeshBackground = () => (
  <div className="absolute z-0 block inset-0 max-w-[100vw]">
    <div className="absolute inset-0 w-full bg-gradient-to-b from-black" />
    <div className="absolute inset-0 w-full bg-gradient-to-b from-black" />
    <MeshGradient />
  </div>
);

export default MeshBackground;
